export default "__VITE_ASSET__BiMxWGXL__"